import animTransform from './animateTransform'
import searchForm from './module/searchForm'
import mainMenu from './module/menu'
import anchorSection from './module/anchorSection'
import {initModal} from "./module/modal";
import scrollToTop from "./module/scrollToTop";
import {debounce} from "./module/utils";

$(window).on('load', function () {
  if (window.innerWidth > 768) {
    anchorSection()
  }
  searchForm()
  initModal()
})

mainMenu()
animTransform()

window.addEventListener("scroll", debounce(scrollToTop, 500));